<div class="content">
    <h2>{{ pageData.header }}</h2>
    <p>{{ pageData.role }} <span>{{ userRole }}</span></p>
    <cms-text class="description" [originalText]="isBusinessUser ? pageData.cbmDescription : pageData.description"></cms-text>
</div>
